module Omni.Booker.Constants {
    export interface IBookerConfiguration {
        ShowBookingWidget: boolean;
        IsBookerOpaque: boolean;
        IsBookerAlwaysOpen: boolean;
        IsBookerExpanded: boolean;
        PageType: string;
        CurrentDate: Date;
        IsBrandPage(): boolean;
        IsResortPage(): boolean;
        IsHotelPage(): boolean;
        ShowExpediaLink: boolean;
        IncludeGha: boolean;
    }

    class BookerConfiguration implements IBookerConfiguration {
        ShowBookingWidget: boolean;
        IsBookerOpaque: boolean;
        IsBookerAlwaysOpen: boolean;
        IsBookerExpanded: boolean;
        PageType: string;
        CurrentDate: Date;
        ShowExpediaLink: boolean;
        IncludeGha: boolean;

        constructor() {
            this.ShowBookingWidget = false;
            this.IsBookerAlwaysOpen = false;
            this.IsBookerOpaque = false;
            this.IsBookerExpanded = false;
            this.PageType = "";
            this.CurrentDate = new Date();
            this.ShowExpediaLink = false;
            this.IncludeGha = false;
        }

        public IsBrandPage() {
            if (this.PageType === "Brand") {
                return true;
            }

            return false;
        }

        public IsResortPage() {
            if (this.PageType === "Resort") {
                return true;
            }

            return false;
        }

        public IsHotelPage() {
            if (this.PageType === "Hotel") {
                return true;
            }

            return false;
        }
    }

    function bookerConfig(): BookerConfiguration {
        var config = new BookerConfiguration();

        var showBookingWidget = angular.element("[name='om-booking-showbookingwidget']");
        config.ShowBookingWidget = showBookingWidget ? showBookingWidget.val() === "True" : false;

        var isBookerOpaque = angular.element("[name='om-booking-isbookeropaque']");
        config.IsBookerOpaque = isBookerOpaque ? isBookerOpaque.val() === "True" : false;

        var isBookerAlwaysOpen = angular.element("[name='om-booking-isbookeralwaysopen']");
        config.IsBookerAlwaysOpen = isBookerAlwaysOpen ? isBookerAlwaysOpen.val() === "True" : false;

        var isBookerExpanded = angular.element("[name='om-booking-isbookerexpanded']");
        config.IsBookerExpanded = isBookerExpanded ? isBookerExpanded.val() === "True" : false;

        var pageType = angular.element("[name='om-booking-pagetype']");
        config.PageType = pageType ? pageType.val() : "";

        var showExpediaLink = angular.element("[name='om-booking-showexpedialink']");
        config.ShowExpediaLink = showExpediaLink ? showExpediaLink.val() === "True" : false;

        var includeGha = angular.element("[name='om-booking-includegha']");
        config.IncludeGha = includeGha ? includeGha.val() === "True" : false;

        var currentDate = angular.element("[name='om-booking-currentdate']");
        var date;
        if (currentDate) {
            date = new Date(parseInt(currentDate.val()));
        } else {
            date = new Date();
        }
        config.CurrentDate = this.moment.utc(date).toDate();
        return config;
    }

    NgModule.constant("bookerConfig", bookerConfig());

    export interface IDateConfiguration {
        MonthsLong: string[];
        MonthsShort: string[];
        WeekdaysLong: string[];
        WeekdaysShort: string[];
    }

    class DateConfiguration {
        MonthsLong: string[];
        MonthsShort: string[];
        WeekdaysLong: string[];
        WeekdaysShort: string[];

        constructor() {
            this.MonthsLong = [];
            this.MonthsShort = [];
            this.WeekdaysLong = [];
            this.WeekdaysShort = [];
        }
    }

    function dateConfig(): DateConfiguration {
        const config = new DateConfiguration();

        const momentConfig = angular.element("input[name='dateConfig']");
        if (momentConfig && momentConfig.length > 0) {
            const parsedViewModel = JSON.parse(momentConfig.val());
            config.MonthsLong = parsedViewModel.LongMonthList.split(",");
            config.MonthsShort = parsedViewModel.ShortMonthList.split(",");
            config.WeekdaysLong = parsedViewModel.LongWeekdayList.split(",");
            config.WeekdaysShort = parsedViewModel.ShortWeekdayList.split(",");
        }

        return config;
    }

    NgModule.constant("dateConfig", dateConfig());
}
